// src/data/bio/index.ts
//
// Typed loader for bio/resume data.
// Source: data/v2/ (MD + JSON) — compiled by scripts/parse-resume-data.mjs at prestart/prebuild.
// Generated files live in src/data/bio/generated/ and are git-ignored.

import type {
  BioProfile,
  BioContact,
  BioExperience,
  BioSkills,
  BioProjects,
  BioCertifications,
  BioData,
} from '../../types/bio';

import profileJson        from './generated/profile.json';
import contactJson        from './generated/contact.json';
import experienceJson     from './generated/experience.json';
import skillsJson         from './generated/skills.json';
import projectsJson       from './generated/projects.json';
import certificationsJson from './generated/certifications.json';

const profile: BioProfile          = profileJson;
const contact: BioContact          = contactJson;
const experience                   = experienceJson     as BioExperience;
const skills: BioSkills            = skillsJson;
const projects                     = projectsJson       as BioProjects;
const certifications: BioCertifications = certificationsJson;

export const bioData: BioData = { profile, contact, experience, skills, projects, certifications };
export { profile, contact, experience, skills, projects, certifications };
